import { Provider } from "react-redux";
import store from "../global/utils/redux/store";
import App from "./App";
import { initJamezzPaths, routes } from "../global/utils/config";
import { createRoot } from "react-dom/client";
import LiveInterface from "../global/components/dev/LiveInterface.tsx";
import { SessionState } from "../kiosk/KioskRouter.tsx";
import ErrorBoundary from "../global/components/ErrorBoundary.tsx";
import InternetConnection from "../global/components/InternetConnection.tsx";
import QrRouter from "./QrRouter.tsx";

initJamezzPaths(routes.qr);

window.globalIntl = null;
window.jamezzApplicationType = "QR";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    // <React.StrictMode>
    <Provider store={store}>
      <LiveInterface />
      <App>
        <InternetConnection />
        <SessionState />
        <ErrorBoundary>
          <QrRouter />
        </ErrorBoundary>
      </App>
    </Provider>
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
